import _defineProperty from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
import { hmac as _hmac } from '@noble/hashes/hmac';
import { concatBytes, randomBytes } from '@noble/hashes/utils';
import { weierstrass } from './abstract/weierstrass.js'; // connects noble-curves to noble-hashes

export function getHash(hash) {
  return {
    hash: hash,
    hmac: function hmac(key) {
      for (var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msgs[_key - 1] = arguments[_key];
      }

      return _hmac(hash, key, concatBytes.apply(void 0, msgs));
    },
    randomBytes: randomBytes
  };
}
export function createCurve(curveDef, defHash) {
  var create = function create(hash) {
    return weierstrass(_objectSpread(_objectSpread({}, curveDef), getHash(hash)));
  };

  return Object.freeze(_objectSpread(_objectSpread({}, create(defHash)), {}, {
    create: create
  }));
}